module.exports = __webpack_public_path__ + "img/why-championla_image1.03944107.jpg";